import api from './api';

export type BillingTaxConfigInput = {
  year: number;
  month: number;
  rbt12: number;
  annex: 'III' | 'V';
  requiresFactorR: boolean;
  factorR: number | null;
};

export type BillingAccountingInput = {
  companyId: string;
  effectiveYear: number;
  effectiveMonth: number;
  metadataKey: string;
  metadataValue: string;
  taxConfigs: BillingTaxConfigInput[];
};

export const productsService = {
  list: () => api.get('/products').then((r) => r.data),
  getById: (id: number) => api.get(`/products/${id}`).then((r) => r.data),
  create: (data: any) => api.post('/products', data).then((r) => r.data),
  update: (id: number, data: any) => api.patch(`/products/${id}`, data).then((r) => r.data),
  delete: (id: number) => api.delete(`/products/${id}`).then((r) => r.data),
  getStages: (id: number) => api.get(`/products/${id}/stages`).then((r) => r.data),
  createStage: (id: number, data: any) =>
    api.post(`/products/${id}/stages`, data).then((r) => r.data),
  updateStage: (id: number, stageId: number, data: any) =>
    api.patch(`/products/${id}/stages/${stageId}`, data).then((r) => r.data),
  deleteStage: (id: number, stageId: number) =>
    api.delete(`/products/${id}/stages/${stageId}`).then((r) => r.data),
  getOrigins: (id: number) => api.get(`/products/${id}/origins`).then((r) => r.data),
  createOrigin: (id: number, name: string) =>
    api.post(`/products/${id}/origins`, { name }).then((r) => r.data),
  updateOrigin: (id: number, originId: number, data: any) =>
    api.patch(`/products/${id}/origins/${originId}`, data).then((r) => r.data),
  getBillingAccounting: (id: number) =>
    api.get(`/products/${id}/billing-accounting`).then((r) => r.data),
  saveBillingAccounting: (id: number, data: BillingAccountingInput) =>
    api.put(`/products/${id}/billing-accounting`, data).then((r) => r.data),
};
